export const ADMIN_VISIBLE_COMPUMATIC_PUNCH_STATUSES = [
  'worker_not_found',
  'clock_not_found',
  'missing_timezone',
  'no_matching_shift',
  'ambiguous_shift',
  'already_punched',
  'missing_clock_in',
  'missing_break_end',
  'missing_break_start',
  'unknown_punch_type',
  'apply_failed',
] as const

export type AdminVisibleCompumaticPunchStatus =
  (typeof ADMIN_VISIBLE_COMPUMATIC_PUNCH_STATUSES)[number]
